// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import ContentSearchController from "./content_search_controller"
application.register("content-search", ContentSearchController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import DaisyUi__DropdownController from "./daisy_ui/dropdown_controller"
application.register("daisy-ui--dropdown", DaisyUi__DropdownController)

import FontSizeController from "./font_size_controller"
application.register("font-size", FontSizeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PagyInitializerController from "./pagy_initializer_controller"
application.register("pagy-initializer", PagyInitializerController)

import PdfReaderController from "./pdf_reader_controller"
application.register("pdf-reader", PdfReaderController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import ShowToastOnClickController from "./show_toast_on_click_controller"
application.register("show-toast-on-click", ShowToastOnClickController)
